const getLastOpenedReportId = ({ report: { services } }) => ({ lastOpenedReportId: services.lastOpenedReportId });

export default getLastOpenedReportId;
